module.exports = __webpack_public_path__ + "img/serviceResource.0c17dae2.png";